/** @format */
// eslint-disable-next-line @mpb-com/mpb/no-relative-import-across-modules -- Legacy code: do not use as an example.
import ProductPage from './product';

// eslint-disable-next-line @mpb-com/mpb/no-relative-import-across-modules -- Legacy code: do not use as an example.
export { getServerSideProps } from './product';
export default ProductPage;
